import { render, staticRenderFns } from "./ApprovalPetitionDetails.vue?vue&type=template&id=6b56aeb2"
import script from "./ApprovalPetitionDetails.vue?vue&type=script&lang=js"
export * from "./ApprovalPetitionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports